/* sugar:assets/progress-bar.js@2.0.0 */
(function () {
  if (customElements.get('sugar-progress-bar')) return;

  function easeOutQuad(t) {
    return t * (2 - t);
  }

  function slice(list) {
    return Array.prototype.slice.call(list);
  }

  /* A figure typed into a line: grouped thousands (4,482 or 1,600.5), or digits with an
     optional decimal part after a point or a comma (72.3, 72,3). */
  var NUMBER = /\d{1,3}(?:,\d{3})+(?:\.\d+)?|\d+(?:[.,]\d+)?/;

  /* A number that names something rather than counts it stays as typed: one joined to a
     word or a # (DS-01, B12, #1), an ordinal or a date (31st, Aug 31, 12.10.2026), a time
     (10:30) or a year. */
  var MONTH = '(?:jan(?:uary)?|feb(?:ruary)?|mar(?:ch)?|apr(?:il)?|may|june?|july?|aug(?:ust)?|sep(?:t(?:ember)?)?|oct(?:ober)?|nov(?:ember)?|dec(?:ember)?)';
  var JOINED = /(?:\p{L}[-‐‑]?|[#№])$/u;
  var MONTH_BEFORE = new RegExp('\\b' + MONTH + '\\.?\\s*$', 'i');
  var NAMING_AFTER = new RegExp('^(?:(?:st|nd|rd|th)\\b|[:h]\\d|[.,]?\\d|\\s*' + MONTH + '\\b)', 'i');
  var YEAR = /^(?:19|20)\d\d$/;

  function readFormat(text) {
    var group = '';
    var point = '.';
    var digits = text;
    if (/^\d{1,3}(?:,\d{3})+(?:\.\d+)?$/.test(text)) {
      group = ',';
      digits = text.replace(/,/g, '');
    } else if (text.indexOf(',') > -1) {
      point = ',';
      digits = text.replace(',', '.');
    }
    var dot = digits.indexOf('.');
    var whole = dot > -1 ? digits.slice(0, dot) : digits;
    return {
      value: parseFloat(digits) || 0,
      places: dot > -1 ? digits.length - dot - 1 : 0,
      group: group,
      point: point,
      pad: whole.length > 1 && whole.charAt(0) === '0' ? whole.length : 1
    };
  }

  function format(n, f) {
    var s = n.toFixed(f.places);
    var dot = s.indexOf('.');
    var whole = dot > -1 ? s.slice(0, dot) : s;
    while (whole.length < f.pad) whole = '0' + whole;
    if (f.group) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, f.group);
    return dot > -1 ? whole + f.point + s.slice(dot + 1) : whole;
  }

  /* Struck text is read as blank, so a crossed-off figure is never the one that counts. */
  function wrapTypedNumber(line) {
    var walker = document.createTreeWalker(line, NodeFilter.SHOW_TEXT);
    var parts = [];
    var text = '';
    var node;
    while ((node = walker.nextNode())) {
      var struck = node.parentNode.closest('s, del, strike');
      parts.push({ node: node, start: text.length });
      text += struck && line.contains(struck) ? node.data.replace(/\S/g, ' ') : node.data;
    }

    var m = NUMBER.exec(text);
    if (!m) return;
    var before = text.slice(0, m.index);
    var after = text.slice(m.index + m[0].length);
    if (JOINED.test(before) || MONTH_BEFORE.test(before) || NAMING_AFTER.test(after) || YEAR.test(m[0])) return;

    for (var i = 0; i < parts.length; i++) {
      var part = parts[i];
      var end = part.start + part.node.data.length;
      if (m.index < part.start || m.index >= end) continue;
      if (m.index + m[0].length > end) return;
      var digits = part.node.splitText(m.index - part.start);
      digits.splitText(m[0].length);
      var span = document.createElement('span');
      span.className = 'sugar-progress-bar__num';
      span.setAttribute('data-pb-to', String(readFormat(m[0]).value));
      span.setAttribute('data-pb-num', m[0]);
      digits.parentNode.insertBefore(span, digits);
      span.appendChild(digits);
      return;
    }
  }

  /* Tokens count in whole numbers; a typed figure keeps its decimals, separators and
     leading zeros, and lands on exactly what was typed. */
  function valueAt(el, eased, t) {
    var f = el._pbFormat;
    if (!f) return Math.round((parseFloat(el.dataset.pbTo) || 0) * eased);
    return t >= 1 ? el.getAttribute('data-pb-num') : format(f.value * eased, f);
  }

  var queue = [];
  var queued = false;
  var watcher = null;

  function watch(bar) {
    if (!watcher) {
      watcher = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          watcher.unobserve(entry.target);
          entry.target._run();
        });
      }, { threshold: 0.2 });
    }
    watcher.observe(bar);
  }

  /* Every bar that connected in the same frame is wound back together: first the markup
     changes that need no measuring, then every measurement, then every write, so the page
     is laid out twice per batch however many bars it holds. */
  function flush() {
    queued = false;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var bars = queue.filter(function (bar) {
      return bar.isConnected && bar._prepare(reduced);
    });
    queue = [];
    if (!bars.length) return;

    /* Hold the width of each final number so nothing beside it shifts while the digits
       tick over. Counting up from zero makes the last frame the widest. */
    var widths = bars.map(function (bar) {
      return bar._numbers.map(function (el) { return el.getBoundingClientRect().width; });
    });

    /* The markup is served finished, so winding it back has to happen without a
       transition or the bar visibly empties itself before it fills. */
    bars.forEach(function (bar, i) { bar._windBack(widths[i]); });
    bars[0].getBoundingClientRect();
    bars.forEach(function (bar) {
      bar._moving.forEach(function (el) { el.style.transition = ''; });
      watch(bar);
    });
  }

  customElements.define('sugar-progress-bar', class extends HTMLElement {
    connectedCallback() {
      this._done = false;
      if (queue.indexOf(this) === -1) queue.push(this);
      if (!queued) {
        queued = true;
        requestAnimationFrame(flush);
      }
    }

    disconnectedCallback() {
      if (watcher) watcher.unobserve(this);
      if (this._raf) cancelAnimationFrame(this._raf);
      this._raf = 0;
      this._done = false;
    }

    _prepare(reduced) {
      this._duration = (parseFloat(this.dataset.duration) || 0) * 1000;
      if (this._duration <= 0 || reduced) return false;

      /* A line that already prints a token keeps counting just that token. */
      slice(this.querySelectorAll('.sugar-progress-bar__line')).forEach(function (line) {
        if (!line.querySelector('[data-pb-to]')) wrapTypedNumber(line);
      });

      this._numbers = slice(this.querySelectorAll('[data-pb-to]'));
      this._numbers.forEach(function (el) {
        el._pbFormat = el.hasAttribute('data-pb-num') ? readFormat(el.getAttribute('data-pb-num')) : null;
      });
      this._moving = slice(
        this.querySelectorAll('.sugar-progress-bar__fill, .sugar-progress-bar__seg, .sugar-progress-bar__inside--over')
      );
      return true;
    }

    _windBack(widths) {
      this._numbers.forEach(function (el, i) {
        if (widths[i] > 0) el.style.minWidth = widths[i] + 'px';
        el.textContent = valueAt(el, 0, 0);
      });
      this._moving.forEach(function (el) { el.style.transition = 'none'; });
      if (this._numbers.length) this.setAttribute('data-pb-count', '');
      this.setAttribute('data-pb-idle', '');
    }

    _run() {
      if (this._done) return;
      this._done = true;
      this.removeAttribute('data-pb-idle');
      var self = this;
      var numbers = this._numbers;
      if (!numbers.length) return;
      var t0 = performance.now();
      function tick(now) {
        if (!self.isConnected) return;
        var t = Math.max(0, Math.min((now - t0) / self._duration, 1));
        var eased = easeOutQuad(t);
        numbers.forEach(function (el) { el.textContent = valueAt(el, eased, t); });
        if (t < 1) {
          self._raf = requestAnimationFrame(tick);
        } else {
          self._raf = 0;
          self.removeAttribute('data-pb-count');
        }
      }
      this._raf = requestAnimationFrame(tick);
    }
  });
})();
